export const pl = {
  common: {
    loading: "Ładowanie...",
    save: "Zapisz",
    cancel: "Anuluj",
    delete: "Usuń",
    edit: "Edytuj",
    create: "Utwórz",
    upload: "Prześlij",
    download: "Pobierz",
    search: "Szukaj",
    filter: "Filtruj",
    back: "Wstecz",
    next: "Dalej",
    close: "Zamknij",
    confirm: "Potwierdź",
    yes: "Tak",
    no: "Nie",
    or: "lub",
    and: "i",
    all: "Wszystkie",
    none: "Brak",
    selected: "Wybrano",
    noResults: "Brak wyników",
    error: "Błąd",
    success: "Sukces",
  },
  auth: {
    login: "Zaloguj się",
    register: "Zarejestruj się",
    logout: "Wyloguj się",
    email: "Email",
    password: "Hasło",
    confirmPassword: "Potwierdź hasło",
    name: "Imię i nazwisko",
    forgotPassword: "Zapomniałeś hasła?",
    resetPassword: "Zresetuj hasło",
    noAccount: "Nie masz konta?",
    haveAccount: "Masz już konto?",
    loginSuccess: "Zalogowano pomyślnie",
    registerSuccess: "Konto utworzone pomyślnie",
    invalidCredentials: "Nieprawidłowy email lub hasło",
    emailRequired: "Email jest wymagany",
    passwordRequired: "Hasło jest wymagane",
    passwordMinLength: "Hasło musi mieć minimum 8 znaków",
  },
  landing: {
    hero: {
      title: "Profesjonalne galerie zdjęć",
      titleHighlight: "dla fotografów",
      subtitle: "Dostarczaj zdjęcia klientom w elegancki sposób. Ochrona hasłem, wybór ulubionych, sprzedaż cyfrowa i wiele więcej.",
      cta: "Rozpocznij za darmo",
      ctaSecondary: "Zobacz demo",
    },
    features: {
      title: "Wszystko czego potrzebujesz",
      subtitle: "Kompletne rozwiązanie dla profesjonalnych fotografów",
      gallery: {
        title: "Piękne galerie",
        description: "Responsywne galerie z układem masonry, slideshow i ochroną hasłem.",
      },
      selection: {
        title: "Wybór zdjęć",
        description: "Klienci oznaczają ulubione zdjęcia i dodają komentarze.",
      },
      sales: {
        title: "Sprzedaż cyfrowa",
        description: "Sprzedawaj zdjęcia online z płatnościami Stripe.",
      },
      ai: {
        title: "AI Tagging",
        description: "Automatyczne tagowanie zdjęć dzięki sztucznej inteligencji.",
      },
      branding: {
        title: "Własny branding",
        description: "Logo, kolory, czcionki - dostosuj wszystko do swojej marki.",
      },
      stats: {
        title: "Statystyki",
        description: "Śledź wyświetlenia, pobrania i aktywność klientów.",
      },
    },
    pricing: {
      title: "Plany cenowe",
      subtitle: "Wybierz plan dopasowany do Twoich potrzeb",
      monthly: "miesięcznie",
      free: {
        name: "Free",
        description: "Dla początkujących",
        features: ["3 galerie", "50 zdjęć na galerię", "1 GB przestrzeni", "Podstawowe statystyki"],
      },
      lite: {
        name: "Lite",
        description: "Dla hobbystów",
        features: ["10 galerii", "200 zdjęć na galerię", "10 GB przestrzeni", "Własny branding", "AI Tagging"],
      },
      pro: {
        name: "Pro",
        description: "Dla profesjonalistów",
        features: ["50 galerii", "500 zdjęć na galerię", "50 GB przestrzeni", "Sprzedaż cyfrowa", "Własna domena"],
      },
      studio: {
        name: "Studio",
        description: "Dla studiów",
        features: ["Nieograniczone galerie", "Nieograniczone zdjęcia", "200 GB przestrzeni", "Zespół użytkowników", "Priorytetowe wsparcie"],
      },
    },
    cta: {
      title: "Gotowy aby zacząć?",
      subtitle: "Dołącz do tysięcy fotografów korzystających z Focus Photo",
      button: "Utwórz darmowe konto",
    },
    footer: {
      copyright: "© 2024 Focus Photo. Wszelkie prawa zastrzeżone.",
      privacy: "Polityka prywatności",
      terms: "Regulamin",
      contact: "Kontakt",
    },
  },
  dashboard: {
    title: "Panel fotografa",
    welcome: "Witaj,",
    stats: {
      galleries: "Galerie",
      photos: "Zdjęcia",
      views: "Wyświetlenia",
      downloads: "Pobrania",
    },
    recentGalleries: "Ostatnie galerie",
    createGallery: "Utwórz galerię",
    noGalleries: "Nie masz jeszcze żadnych galerii",
    viewAll: "Zobacz wszystkie",
  },
  gallery: {
    title: "Galeria",
    create: "Utwórz galerię",
    edit: "Edytuj galerię",
    delete: "Usuń galerię",
    deleteConfirm: "Czy na pewno chcesz usunąć tę galerię?",
    name: "Nazwa galerii",
    clientName: "Nazwa klienta",
    password: "Hasło (opcjonalne)",
    passwordHint: "Zostaw puste dla galerii publicznej",
    expiresAt: "Data wygaśnięcia",
    layout: "Układ",
    layouts: {
      masonry: "Masonry",
      grid: "Siatka",
      fullscreen: "Pełny ekran",
    },
    watermark: "Znak wodny",
    watermarkEnabled: "Włączony",
    downloadEnabled: "Pobieranie włączone",
    photos: "Zdjęcia",
    uploadPhotos: "Prześlij zdjęcia",
    dropzone: "Przeciągnij zdjęcia tutaj lub kliknij aby wybrać",
    dropzoneActive: "Upuść zdjęcia tutaj...",
    uploadProgress: "Przesyłanie...",
    photoCount: "zdjęć",
    viewGallery: "Zobacz galerię",
    copyLink: "Kopiuj link",
    linkCopied: "Link skopiowany!",
    shareGallery: "Udostępnij galerię",
    noPhotos: "Brak zdjęć w galerii",
    selectAll: "Zaznacz wszystkie",
    deselectAll: "Odznacz wszystkie",
    deleteSelected: "Usuń zaznaczone",
    analyzeAI: "Analizuj AI",
  },
  publicGallery: {
    enterPassword: "Wprowadź hasło",
    passwordRequired: "Ta galeria jest chroniona hasłem",
    incorrectPassword: "Nieprawidłowe hasło",
    expired: "Ta galeria wygasła",
    favorites: "Ulubione",
    comments: "Komentarze",
    addComment: "Dodaj komentarz",
    yourName: "Twoje imię",
    commentPlaceholder: "Napisz komentarz...",
    downloadAll: "Pobierz wszystkie",
    downloadSelected: "Pobierz wybrane",
    downloadSingle: "Pobierz",
    addToFavorites: "Dodaj do ulubionych",
    removeFromFavorites: "Usuń z ulubionych",
    viewFullscreen: "Zobacz w pełnym ekranie",
    slideshow: "Pokaz slajdów",
    addToCart: "Dodaj do koszyka",
  },
  cart: {
    title: "Koszyk",
    empty: "Koszyk jest pusty",
    item: "Pozycja",
    quantity: "Ilość",
    price: "Cena",
    total: "Razem",
    checkout: "Przejdź do płatności",
    remove: "Usuń",
    continueShopping: "Kontynuuj zakupy",
  },
  settings: {
    title: "Ustawienia",
    account: "Konto",
    branding: "Branding",
    billing: "Rozliczenia",
    language: "Język",
    theme: "Motyw",
    logo: "Logo",
    uploadLogo: "Prześlij logo",
    primaryColor: "Kolor główny",
    secondaryColor: "Kolor drugorzędny",
    fontFamily: "Czcionka",
    customDomain: "Własna domena",
    currentPlan: "Aktualny plan",
    upgradePlan: "Zmień plan",
    saved: "Zapisano zmiany",
  },
  errors: {
    generic: "Wystąpił błąd. Spróbuj ponownie.",
    network: "Błąd połączenia. Sprawdź internet.",
    notFound: "Nie znaleziono",
    unauthorized: "Brak autoryzacji",
    forbidden: "Brak dostępu",
    serverError: "Błąd serwera",
  },
  clients: {
    title: "Klienci",
    new: "Nowy klient",
    add: "Dodaj klienta",
    edit: "Edytuj klienta",
    delete: "Usuń klienta",
    searchPlaceholder: "Szukaj klientów...",
    columns: {
      client: "Klient",
      contact: "Kontakt",
      selections: "Selekcje",
      orders: "Zamówienia",
    },
    form: {
      name: "Imię i nazwisko",
      email: "Email",
      phone: "Telefon",
      notes: "Notatki",
    },
    empty: "Brak klientów",
    emptyHint: "Dodaj pierwszego klienta, aby rozpocząć",
    noResults: "Nie znaleziono klientów",
  },
  orders: {
    title: "Zamówienia",
    new: "Nowe zamówienie",
    edit: "Edytuj zamówienie",
    delete: "Usuń zamówienie",
    searchPlaceholder: "Szukaj zamówień...",
    columns: {
      orderNumber: "Nr zamówienia",
      client: "Klient",
      gallery: "Galeria",
      amount: "Kwota",
      status: "Status",
      date: "Data",
    },
    statuses: {
      pending: "Oczekuje",
      paid: "Opłacone",
      delivered: "Dostarczone",
      cancelled: "Anulowane",
    },
    empty: "Brak zamówień",
    emptyHint: "Utwórz pierwsze zamówienie, aby rozpocząć",
  },
  selections: {
    title: "Selekcje",
    statuses: {
      submitted: "Przesłana",
      reviewed: "Przeglądana",
      approved: "Zatwierdzona",
    },
    empty: "Brak selekcji",
    emptyHint: "Klienci mogą wybierać zdjęcia z publicznej galerii",
    photos: "zdjęć",
    exportCsv: "Eksportuj CSV",
    exportXmp: "Eksport XMP dla Lightroom",
    xmpExported: "Eksport XMP dla Lightroom pobrany",
  },
  curator: {
    title: "Kurator",
    accepted: "zaakceptowanych",
    rejected: "odrzuconych",
    pending: "oczekujących",
    saveAll: "Zapisz wszystkie decyzje",
    accept: "Akceptuj",
    reject: "Odrzuć",
    reset: "Cofnij",
  },
  album: {
    title: "Album",
    designer: "Magic Designer",
    analyzePhotos: "Analizuj zdjęcia",
    generateLayout: "Wygeneruj layout",
    generateCover: "Wygeneruj okładkę",
    pageCount: "Liczba stron",
    format: "Format",
    topic: "Temat",
    style: "Styl",
    spread: "Rozkładówka",
    single: "Pojedyncza",
    grid: "Siatka",
    print: "Drukuj",
    exportPdf: "Eksportuj PDF",
  },
};

export const en = {
  common: {
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    upload: "Upload",
    download: "Download",
    search: "Search",
    filter: "Filter",
    back: "Back",
    next: "Next",
    close: "Close",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    or: "or",
    and: "and",
    all: "All",
    none: "None",
    selected: "Selected",
    noResults: "No results",
    error: "Error",
    success: "Success",
  },
  auth: {
    login: "Log in",
    register: "Sign up",
    logout: "Log out",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm password",
    name: "Full name",
    forgotPassword: "Forgot password?",
    resetPassword: "Reset password",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    loginSuccess: "Logged in successfully",
    registerSuccess: "Account created successfully",
    invalidCredentials: "Invalid email or password",
    emailRequired: "Email is required",
    passwordRequired: "Password is required",
    passwordMinLength: "Password must be at least 8 characters",
  },
  landing: {
    hero: {
      title: "Professional photo galleries",
      titleHighlight: "for photographers",
      subtitle: "Deliver photos to your clients in an elegant way. Password protection, favorites selection, digital sales and more.",
      cta: "Start for free",
      ctaSecondary: "View demo",
    },
    features: {
      title: "Everything you need",
      subtitle: "Complete solution for professional photographers",
      gallery: {
        title: "Beautiful galleries",
        description: "Responsive galleries with masonry layout, slideshow and password protection.",
      },
      selection: {
        title: "Photo selection",
        description: "Clients mark favorite photos and add comments.",
      },
      sales: {
        title: "Digital sales",
        description: "Sell photos online with Stripe payments.",
      },
      ai: {
        title: "AI Tagging",
        description: "Automatic photo tagging powered by artificial intelligence.",
      },
      branding: {
        title: "Custom branding",
        description: "Logo, colors, fonts - customize everything to match your brand.",
      },
      stats: {
        title: "Statistics",
        description: "Track views, downloads and client activity.",
      },
    },
    pricing: {
      title: "Pricing plans",
      subtitle: "Choose a plan that fits your needs",
      monthly: "monthly",
      free: {
        name: "Free",
        description: "For beginners",
        features: ["3 galleries", "50 photos per gallery", "1 GB storage", "Basic statistics"],
      },
      lite: {
        name: "Lite",
        description: "For hobbyists",
        features: ["10 galleries", "200 photos per gallery", "10 GB storage", "Custom branding", "AI Tagging"],
      },
      pro: {
        name: "Pro",
        description: "For professionals",
        features: ["50 galleries", "500 photos per gallery", "50 GB storage", "Digital sales", "Custom domain"],
      },
      studio: {
        name: "Studio",
        description: "For studios",
        features: ["Unlimited galleries", "Unlimited photos", "200 GB storage", "Team users", "Priority support"],
      },
    },
    cta: {
      title: "Ready to start?",
      subtitle: "Join thousands of photographers using Focus Photo",
      button: "Create free account",
    },
    footer: {
      copyright: "© 2024 Focus Photo. All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      contact: "Contact",
    },
  },
  dashboard: {
    title: "Photographer Dashboard",
    welcome: "Welcome,",
    stats: {
      galleries: "Galleries",
      photos: "Photos",
      views: "Views",
      downloads: "Downloads",
    },
    recentGalleries: "Recent galleries",
    createGallery: "Create gallery",
    noGalleries: "You don't have any galleries yet",
    viewAll: "View all",
  },
  gallery: {
    title: "Gallery",
    create: "Create gallery",
    edit: "Edit gallery",
    delete: "Delete gallery",
    deleteConfirm: "Are you sure you want to delete this gallery?",
    name: "Gallery name",
    clientName: "Client name",
    password: "Password (optional)",
    passwordHint: "Leave empty for public gallery",
    expiresAt: "Expiration date",
    layout: "Layout",
    layouts: {
      masonry: "Masonry",
      grid: "Grid",
      fullscreen: "Fullscreen",
    },
    watermark: "Watermark",
    watermarkEnabled: "Enabled",
    downloadEnabled: "Download enabled",
    photos: "Photos",
    uploadPhotos: "Upload photos",
    dropzone: "Drag photos here or click to select",
    dropzoneActive: "Drop photos here...",
    uploadProgress: "Uploading...",
    photoCount: "photos",
    viewGallery: "View gallery",
    copyLink: "Copy link",
    linkCopied: "Link copied!",
    shareGallery: "Share gallery",
    noPhotos: "No photos in gallery",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    deleteSelected: "Delete selected",
    analyzeAI: "Analyze AI",
  },
  publicGallery: {
    enterPassword: "Enter password",
    passwordRequired: "This gallery is password protected",
    incorrectPassword: "Incorrect password",
    expired: "This gallery has expired",
    favorites: "Favorites",
    comments: "Comments",
    addComment: "Add comment",
    yourName: "Your name",
    commentPlaceholder: "Write a comment...",
    downloadAll: "Download all",
    downloadSelected: "Download selected",
    downloadSingle: "Download",
    addToFavorites: "Add to favorites",
    removeFromFavorites: "Remove from favorites",
    viewFullscreen: "View fullscreen",
    slideshow: "Slideshow",
    addToCart: "Add to cart",
  },
  cart: {
    title: "Cart",
    empty: "Cart is empty",
    item: "Item",
    quantity: "Quantity",
    price: "Price",
    total: "Total",
    checkout: "Checkout",
    remove: "Remove",
    continueShopping: "Continue shopping",
  },
  settings: {
    title: "Settings",
    account: "Account",
    branding: "Branding",
    billing: "Billing",
    language: "Language",
    theme: "Theme",
    logo: "Logo",
    uploadLogo: "Upload logo",
    primaryColor: "Primary color",
    secondaryColor: "Secondary color",
    fontFamily: "Font family",
    customDomain: "Custom domain",
    currentPlan: "Current plan",
    upgradePlan: "Change plan",
    saved: "Changes saved",
  },
  errors: {
    generic: "An error occurred. Please try again.",
    network: "Connection error. Check your internet.",
    notFound: "Not found",
    unauthorized: "Unauthorized",
    forbidden: "Access denied",
    serverError: "Server error",
  },
  clients: {
    title: "Clients",
    new: "New client",
    add: "Add client",
    edit: "Edit client",
    delete: "Delete client",
    searchPlaceholder: "Search clients...",
    columns: {
      client: "Client",
      contact: "Contact",
      selections: "Selections",
      orders: "Orders",
    },
    form: {
      name: "Full name",
      email: "Email",
      phone: "Phone",
      notes: "Notes",
    },
    empty: "No clients",
    emptyHint: "Add your first client to get started",
    noResults: "No clients found",
  },
  orders: {
    title: "Orders",
    new: "New order",
    edit: "Edit order",
    delete: "Delete order",
    searchPlaceholder: "Search orders...",
    columns: {
      orderNumber: "Order number",
      client: "Client",
      gallery: "Gallery",
      amount: "Amount",
      status: "Status",
      date: "Date",
    },
    statuses: {
      pending: "Pending",
      paid: "Paid",
      delivered: "Delivered",
      cancelled: "Cancelled",
    },
    empty: "No orders",
    emptyHint: "Create your first order to get started",
  },
  selections: {
    title: "Selections",
    statuses: {
      submitted: "Submitted",
      reviewed: "Reviewed",
      approved: "Approved",
    },
    empty: "No selections",
    emptyHint: "Clients can select photos from the public gallery",
    photos: "photos",
    exportCsv: "Export CSV",
    exportXmp: "Export XMP for Lightroom",
    xmpExported: "XMP export for Lightroom downloaded",
  },
  curator: {
    title: "Curator",
    accepted: "accepted",
    rejected: "rejected",
    pending: "pending",
    saveAll: "Save all decisions",
    accept: "Accept",
    reject: "Reject",
    reset: "Reset",
  },
  album: {
    title: "Album",
    designer: "Magic Designer",
    analyzePhotos: "Analyze photos",
    generateLayout: "Generate layout",
    generateCover: "Generate cover",
    pageCount: "Page count",
    format: "Format",
    topic: "Topic",
    style: "Style",
    spread: "Spread",
    single: "Single",
    grid: "Grid",
    print: "Print",
    exportPdf: "Export PDF",
  },
};
